import type { WhatsappNaFicha } from "../../../services/whatsapp";

const soDigitos = (texto: string | null | undefined) => (texto ?? "").replace(/\D/g, "");

export const normalizarNumero = (texto: string | null | undefined): string | null => {
  const digitos = soDigitos(texto).replace(/^0+/, "");
  if (digitos.startsWith("55") && (digitos.length === 12 || digitos.length === 13)) return digitos;
  if (digitos.length === 10 || digitos.length === 11) return `55${digitos}`;
  return null;
};

export const linkWaMe = (texto: string | null | undefined): string | null => {
  const numero = normalizarNumero(texto);
  return numero ? `https://wa.me/${numero}` : null;
};

export const formatarParaCampo = (numero: string | null | undefined): string => {
  const n = normalizarNumero(numero);
  if (!n) return numero ?? "";
  const ddd = n.slice(2, 4);
  const resto = n.slice(4);
  const corte = resto.length - 4;
  return `(${ddd}) ${resto.slice(0, corte)}-${resto.slice(corte)}`;
};

export const formatarNumero = (numero: string | null | undefined): string => {
  const campo = formatarParaCampo(numero);
  return normalizarNumero(numero) ? `+55 ${campo}` : campo;
};

export const numerosDiferem = (dados: WhatsappNaFicha | null): boolean =>
  Boolean(
    dados?.numeroGeoranking &&
      dados?.numeroNoGoogle &&
      normalizarNumero(dados.numeroGeoranking) !== normalizarNumero(dados.numeroNoGoogle),
  );
